"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CmsBotsListCtl = /** @class */ (function (_super) {
    __extends(CmsBotsListCtl, _super);
    function CmsBotsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_bot_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bot_tag; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_usr_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_id; });
        _this.dk_usr_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_login; });
        _this.dk_app_currency_iso = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_iso; });
        _this.dk_gws_gameprovider_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_id; });
        _this.dk_gws_gameprovider_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_title; });
        _this.dk_gws_gameprovider_game_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_id; });
        _this.dk_gws_gameprovider_game_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_title; });
        _this.dk_cms_gameprovider_gameset_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameprovider_gameset_id; });
        _this.dk_cms_gameprovider_gameset_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameprovider_gameset_title; });
        _this.dk_is_auto_change_game = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_auto_change_game; });
        _this.dk_change_game_min_timeout_sec = UIUtils_1.UIUtils.IProp2Str(function (o) { o.change_game_min_timeout_sec; });
        _this.dk_change_game_max_timeout_sec = UIUtils_1.UIUtils.IProp2Str(function (o) { o.change_game_max_timeout_sec; });
        _this.dk_min_win_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_win_amount; });
        _this.dk_max_win_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_win_amount; });
        _this.dk_min_timeout_win_sec = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_timeout_win_sec; });
        _this.dk_max_timeout_win_sec = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_timeout_win_sec; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    CmsBotsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    CmsBotsListCtl.prototype.getById = function (key) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                return this.DATA.data[i];
            }
        }
        throw "winner regular with (key) -> [" + key + "] not found !";
    };
    CmsBotsListCtl.prototype.LoadData = function (allBrands, brandsIdList, onDone) {
        var _this = this;
        webAApi_1.ListCmsBotsByBrandIdGet.exec({ brand_id_list: brandsIdList, all_brands: allBrands }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    bot_tag: resp.list[i].bot_tag,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    gws_gameprovider_id: resp.list[i].gws_gameprovider_id,
                    gws_gameprovider_title: resp.list[i].gws_gameprovider_title,
                    gws_gameprovider_game_id: resp.list[i].gws_gameprovider_game_id,
                    gws_gameprovider_game_title: resp.list[i].gws_gameprovider_game_title,
                    min_timeout_win_sec: resp.list[i].min_timeout_win_sec,
                    max_timeout_win_sec: resp.list[i].max_timeout_win_sec,
                    is_locked: resp.list[i].is_locked,
                    min_win_amount: resp.list[i].min_win_amount,
                    max_win_amount: resp.list[i].max_win_amount,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    cms_gameprovider_gameset_id: resp.list[i].cms_gameprovider_gameset_id,
                    cms_gameprovider_gameset_title: resp.list[i].cms_gameprovider_gameset_title,
                    is_auto_change_game: resp.list[i].is_auto_change_game,
                    change_game_min_timeout_sec: resp.list[i].change_game_min_timeout_sec,
                    change_game_max_timeout_sec: resp.list[i].change_game_max_timeout_sec,
                    app_currency_iso: resp.list[i].app_currency_iso
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsBotsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddCmsBot.exec({
            data: {
                bot_tag: data.bot_tag,
                brand_id: data.brand_id,
                usr_player_id: data.usr_player_id,
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                min_win_amount: data.min_win_amount,
                max_win_amount: data.max_win_amount,
                min_timeout_win_sec: data.min_timeout_win_sec,
                max_timeout_win_sec: data.max_timeout_win_sec,
                is_locked: data.is_locked,
                cms_gameprovider_gameset_id: data.cms_gameprovider_gameset_id,
                change_game_min_timeout_sec: data.change_game_min_timeout_sec,
                change_game_max_timeout_sec: data.change_game_max_timeout_sec,
                is_auto_change_game: data.is_auto_change_game
            }
        }, function (resp) {
            _this.DATA.data.push({
                usr_player_id: data.usr_player_id,
                usr_player_login: resp.player_login,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                gws_gameprovider_game_title: resp.gws_gameprovider_game_title,
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_title: resp.gws_gameprovider_title,
                is_locked: data.is_locked,
                min_win_amount: data.min_win_amount,
                max_win_amount: data.max_win_amount,
                bot_tag: data.bot_tag,
                min_timeout_win_sec: data.min_timeout_win_sec,
                max_timeout_win_sec: data.max_timeout_win_sec,
                key: resp.key_uid,
                cms_gameprovider_gameset_id: data.cms_gameprovider_gameset_id,
                cms_gameprovider_gameset_title: resp.cms_gameprovider_gameset_title,
                is_auto_change_game: data.is_auto_change_game,
                change_game_min_timeout_sec: data.change_game_min_timeout_sec,
                change_game_max_timeout_sec: data.change_game_max_timeout_sec,
                app_currency_iso: resp.app_currency_iso
            });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsBotsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditCmsBot.exec({
                data: {
                    cms_bot_id: data.key,
                    bot_tag: data.bot_tag,
                    usr_player_id: data.usr_player_id,
                    gws_gameprovider_id: data.gws_gameprovider_id,
                    gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                    min_win_amount: data.min_win_amount,
                    max_win_amount: data.max_win_amount,
                    min_timeout_win_sec: data.min_timeout_win_sec,
                    max_timeout_win_sec: data.max_timeout_win_sec,
                    is_locked: data.is_locked,
                    cms_gameprovider_gameset_id: data.cms_gameprovider_gameset_id,
                    is_auto_change_game: data.is_auto_change_game,
                    change_game_min_timeout_sec: data.change_game_min_timeout_sec,
                    change_game_max_timeout_sec: data.change_game_max_timeout_sec
                }
            }, function (resp) {
                _tmp.bot_tag = data.bot_tag;
                _tmp.usr_player_id = data.usr_player_id;
                _tmp.usr_player_login = resp.player_login;
                _tmp.gws_gameprovider_id = data.gws_gameprovider_id;
                _tmp.gws_gameprovider_title = resp.gws_gameprovider_title;
                _tmp.gws_gameprovider_game_id = data.gws_gameprovider_game_id;
                _tmp.gws_gameprovider_game_title = resp.gws_gameprovider_game_title;
                _tmp.min_win_amount = data.min_win_amount;
                _tmp.max_win_amount = data.max_win_amount;
                _tmp.min_timeout_win_sec = data.min_timeout_win_sec;
                _tmp.max_timeout_win_sec = data.max_timeout_win_sec;
                _tmp.is_locked = data.is_locked;
                _tmp.cms_gameprovider_gameset_id = data.cms_gameprovider_gameset_id;
                _tmp.cms_gameprovider_gameset_title = resp.cms_gameprovider_gameset_title;
                _tmp.is_auto_change_game = data.is_auto_change_game;
                _tmp.change_game_min_timeout_sec = data.change_game_min_timeout_sec;
                _tmp.change_game_max_timeout_sec = data.change_game_max_timeout_sec;
                _tmp.app_currency_iso = resp.app_currency_iso;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsBotsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CmsBotsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteCmsBot.exec({ data: { cms_bot_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsBotsListCtl.prototype.doSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetCmsBotIsLocked.exec({
                data: {
                    cms_bot_id: key,
                    is_locked: isLocked
                }
            }, function (resp) {
                _tmp.is_locked = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CmsBotsListCtl;
}(BaseController_1.BaseController));
exports.CmsBotsListCtl = CmsBotsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_bots/ctl/CmsBotsListCtl.ts
// module id = 927
// module chunks = 0